import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { useQuery } from 'react-apollo'

import routes from 'src/lib/rails-routes/rails-routes'
import UnitVocabulary from 'src/pages/UnitVocabulary/UnitVocabulary'
import UnitVocabularyPlaceholder from 'src/pages/UnitVocabulary/UnitVocabularyPlaceholder'
import DataFetchError from 'src/ui/DataFetchError/DataFetchError'

export const FETCH_VOCABULARY_LIST = gql`
  query UNITS_WORDS(
    $unitId: ID!
    $l1Code: LanguageEnum!
    $l2Code: LanguageEnum!
  ) {
    curriculum(native: $l1Code, learning: $l2Code) {
      unit(id: $unitId) {
        id
        gid
        sequences {
          studyableId
          word: label
          linkToItem
          studyCard {
            progress
            tooltip
          }
        }
        words {
          studyableId
          word
          linkToItem
          studyCard {
            progress
            tooltip
          }
        }
      }
    }
  }
`

const UnitVocabularyLazy = (props) => {
  const { l1Code, l2Code, unitId } = props

  const response = useQuery(FETCH_VOCABULARY_LIST, {
    variables: {
      unitId,
      l1Code,
      l2Code,
    },
  })

  const { data, loading } = response
  const words = data?.curriculum?.unit?.words
  const sequences = data?.curriculum?.unit?.sequences
  const gid = data?.curriculum?.unit?.gid

  let vocabulary = null
  if (words || sequences) {
    vocabulary = [...(words || []), ...(sequences || [])]
  }

  if (loading) {
    return <UnitVocabularyPlaceholder />
  }

  if (vocabulary) {
    const studyVocabularyLink = routes.cards_for_lesson(l2Code, gid)
    return (
      <UnitVocabulary
        vocabularyList={vocabulary}
        studyVocabularyLink={studyVocabularyLink}
      />
    )
  }

  return <DataFetchError graphQLResponse={response} />
}

UnitVocabularyLazy.propTypes = {
  l1Code: PropTypes.string.isRequired,
  l2Code: PropTypes.string.isRequired,
  unitId: PropTypes.number.isRequired,
}

export default UnitVocabularyLazy
